import React from "react";
import { connect } from "react-redux";
import { CertificateDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Displays, Forms, Modals } from "components";

class CertificateDetailContainer extends React.Component {
  state = {
    isLoading: true,
  };

  componentDidMount() {
    // if (this.props.router.params.id !== "create") {
    this.fetchData();
    // } else {
    //   this.setState({
    //     isLoading: false,
    //     isBgLoading: false,
    //   });
    // }
  }

  fetchData = async () => {
    // certificate ผูกได้ 2 ชนิด จึงต้องโหลด option ทั้งสองฝั่งไว้ให้ฟอร์มสลับ
    const READY_QUERY = `?pagination=false&is_certificate_ready=true`;
    const toOption = (e) => ({ ...e, label: e.name_th, value: e._id });
    if (this.props.router.params.id === "create") {
      let res = await Promise.all([
        portalService.GET_ACTIVITY_FORM_LIST(READY_QUERY),
        portalService.GET_ACTIVITY_LIST(READY_QUERY),
      ]);
      if (res) {
        this.setState({
          activitiOption: res[0].data.docs.map(toOption),
          activityOption: res[1].data.docs.map(toOption),
          isLoading: false,
          isBgLoading: false,
        });
      }
    } else {
      let res = await Promise.all([
        portalService.GET_CERTIFICATE_DETAIL(this.props.router.params.id),
        portalService.GET_ACTIVITY_FORM_LIST(READY_QUERY),
        portalService.GET_ACTIVITY_LIST(READY_QUERY),
      ]);
      if (res) {
        // เดิม map label: e.name ซึ่ง activity_form ไม่มี field นี้ ตัวเลือกเลยว่างเปล่า
        let actFormOptionTemp = res[1].data.docs.map(toOption);
        let actOptionTemp = res[2].data.docs.map(toOption);
        // ตัวที่ผูกอยู่ถูกกรองออกจาก is_certificate_ready ต้องใส่กลับให้เลือกค้างไว้ได้
        if (res[0].data.activity_ref_id) {
          const current = {
            label: res[0].data.activity_name,
            value: res[0].data.activity_ref_id,
          };
          if (res[0].data.ref_type === "2") {
            actOptionTemp.push(current);
          } else {
            actFormOptionTemp.push(current);
          }
        }
        this.setState({
          initialValues: res[0].data,
          activitiOption: actFormOptionTemp,
          activityOption: actOptionTemp,
          isLoading: false,
          isBgLoading: false,
        });
        // ใบของ activity ให้ดึง qrcode ของกิจกรรมมาแสดงในหน้านี้ด้วย
        // แอดมินจะได้หยิบ qrcode ได้จากทั้งเมนู Activity และเมนู Certificate
        // ต้องยิงแยกเพราะกิจกรรมที่ผูกแล้วถูกกรองออกจาก is_certificate_ready
        if (res[0].data.ref_type === "2" && res[0].data.activity_ref_id) {
          this.fetchLinkedActivity(res[0].data.activity_ref_id);
        }
      }
    }
  };

  fetchLinkedActivity = async (activityId) => {
    let res = await portalService.GET_ACTIVITY_DETAIL(activityId);
    if (res && res.status === 200) {
      this.setState({ linkedActivity: res.data });
    }
  };

  // FLOW DELETE
  // =============================
  // =============================
  handleDelete = () => {
    this.setState({
      renderModal: (
        <Displays.CofirmBox
          label="คุณต้องการลบใช่หรือไม่ ?"
          labelBtn1="Confirm"
          labelBtn2="Cancel"
          onAction1={this.deleteAction}
          onAction2={this.handleCloseModal}
        />
      ),
    });
  };
  deleteAction = async () => {
    this.setState({
      isBgLoading: true,
    });
    let res = await portalService.DELETE_CETIFICATE_DETAIL(
      this.props.router.params.id,
    );
    if (res && res.status === 200) {
      toast.success("ลบสำเร็จ");
      this.handleNextStep();
    } else {
      toast.error("ลบไม่สำรเร็จ");
    }
  };

  handleCloseModal = () => {
    this.setState({
      renderModal: null,
    });
  };

  // FLOW SUBMIT
  // =============================
  // =============================
  handleSubmit = async (values) => {
    const { activitiOption, activityOption, initialValues } = this.state;
    this.setState({
      isBgLoading: true,
    });
    // ชนิดล็อกตั้งแต่ตอนสร้าง ตอนแก้ไขให้ยึดค่าเดิมเสมอ
    const refType =
      (initialValues ? initialValues.ref_type : values.ref_type) === "2"
        ? "2"
        : "1";
    const options = refType === "2" ? activityOption : activitiOption;
    let find = (options || []).find((e) => e.value === values.activity_ref_id);
    if (!find) {
      this.setState({ isBgLoading: false });
      toast.error("กรุณาเลือกกิจกรรม");
      return;
    }
    let params = {
      ...values,
      ref_type: refType,
      activity_ref_id: find.value,
      activity_name: find.label,
    };
    let res =
      this.props.router.params.id === "create"
        ? await portalService.POST_CERTIFICATE_DETAIL(params)
        : await portalService.PUT_CERTIFICATE_UPDATE(
            this.props.router.params.id,
            params,
          );
    if (res && res.status === 200) {
      let filesTemp = [];
      filesTemp = [...values.img_file.filter((e) => e.isNewUpload)];
      if (filesTemp.length === 0) {
        toast.success("อัพเดตสำเร็จ");
        this.handleCloseModal();
        this.handleNextStep();
      } else {
        this.handleUploadContentMedia(res.data._id, filesTemp);
      }
    } else {
      this.handleCloseModal();
      toast.error("อัพเดตไม่สำเร็จ");
    }
  };
  handleUploadContentMedia = (certificateID, files) => {
    Promise.all(
      files.map((e) => {
        return new Promise(async (resolve) => {
          if (e.isNewUpload) {
            const bodyFormData = new FormData();
            bodyFormData.set("certificate_id", certificateID);
            bodyFormData.set("type", e.fieldName);
            bodyFormData.append("image", e);
            let res = await portalService.POST_CERTIFICATE_UPLOAD(bodyFormData);
            if (res && res.status === 200) {
              resolve();
            }
          }
        });
      }),
    ).then(() => {
      this.handleCloseModal();
      this.setState({
        isBgLoading: false,
      });
      toast.success("อัพเดจสำเร็จ");
      this.handleNextStep();
    });
  };

  handleCancel = () => {
    this.props.router.navigate(-1);
  };

  handleNextStep = () => {
    this.props.router.navigate(ROUTE_PATH.CERTIFICATE);
  };

  render() {
    const { authenRedux } = this.props;
    const {
      isLoading,
      initialValues,
      isBgLoading,
      activitiOption,
      activityOption,
      linkedActivity,
      renderModal,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "certificate");
    return (
      <CertificateDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading && !activitiOption ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <Forms.CertificateForm
            activitiOption={activitiOption}
            activityOption={activityOption}
            linkedActivity={linkedActivity}
            initialValues={initialValues}
            permission={permission}
            onCancel={this.handleCancel}
            onDelete={this.handleDelete}
            onSubmit={this.handleSubmit}
          />
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </CertificateDetailContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(CertificateDetailContainer));
